@if (dataSource.data.length ===0 && !isLoadingData()) {
  <tkc-no-data/>
} @else {
  <mic-year-scroller class="year-scroller" [(year)]="startYear" [rightDisabled]=!canSelectNextYear() />

  <div id="tab-content">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="seat">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'stock.table.seat' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.tireSpec.seat }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="tireSpec">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="column-tire-spec">{{ 'stock.table.tireSpec' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-tire-spec">{{ element.tireSpec.specification }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="column-tire-spec">{{ 'stock.table.total' | translate }}</mat-footer-cell>
      </ng-container>

      @for (monthNumber of monthsNumbersToDisplay; track monthNumber) {
        <ng-container matColumnDef="{{ monthNumber }}">
          <mat-header-cell *matHeaderCellDef class="table-number">
            <div class="month-header">
              <span>{{ 'common.months.' + monthNumber | translate }}</span>
              <span class="year">{{ getYearForMonth(monthNumber) }}</span>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element, let rowIndex = index" [ngClass]="getMonthClass(monthNumber, getYearForMonth(monthNumber))" class="table-data">
            <div class="input-edited-wrapper" [ngClass]="!isEditableMonth(monthNumber, getYearForMonth(monthNumber)) ? 'tkc-number' : ''">
              @if (element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.corrected || element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.modified) {
                <span class="input-edited-marker"></span>
              }
              @if (isEditableMonth(monthNumber, getYearForMonth(monthNumber))) {
                <ng-container>
                  <input matInput
                         type="text"
                         maxlength="3"
                         nxNoScroll
                         [mask]="digitMask"
                         [patterns]="digitPatterns"
                         class="tkc-input"
                         matTooltip="Automatic data: {{ element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.tireStockQty }}"
                         [formControl]="getQuantityControl(element.tireSpec.tireSpecId)"
                         (keydown.enter)="updateColumns(element, monthNumber, getQuantityControl(element.tireSpec.tireSpecId))"
                         (change)="updateColumns(element, monthNumber, getQuantityControl(element.tireSpec.tireSpecId))"/>
                </ng-container>
              } @else {
                {{ element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.corrected
                ? element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.stockCorrection
                : element.stocksByMonth[getFirstDayOfMonth(monthNumber)]?.tireStockQty ?? '-' }}
              }
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef [ngClass]="getMonthClass(monthNumber, getYearForMonth(monthNumber))" class="table-data tkc-number">
            {{ getTotalForMonth(monthNumber) }}
          </mat-footer-cell>
        </ng-container>
      }

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>{{ 'stock.table.action' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button mat-icon-button class="mic-icon-button-large"
                matTooltip = "{{ 'stock.table.revertTooltip' | translate }}"
                (click)="revertLineModifications(element)"
                [disabled]="isCurrentMonthCorrected(element)">
          <mat-icon>undo</mat-icon>
        </button>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

      <mat-header-row *matHeaderRowDef="columns"/>
      <mat-row *matRowDef="let row; columns: columns"/>
      <mat-footer-row *matFooterRowDef="columns"/>
    </mat-table>
  </div>

  <mic-year-scroller class="year-scroller" [(year)]="startYear" [rightDisabled]=!canSelectNextYear() />

  <div id="tab-content-footer" class="card-side-padding card-bottom-padding">
    <mat-icon class="edited-icon">circle</mat-icon>
    <span>{{ 'common.legend.redPoint' | translate }}</span>
  </div>
}
